import { PopUp, StateHandler, useClasses } from "../../";
import React from "react";
const styles = (theme) => ({
    menuSection: {
        margin: 0,
        fontWeight: 400,
        color: theme.palette.get("primary"),
        letterSpacing: "0.75px",
        fontSize: "1rem",
    },
    seperator: {
        margin: "10px -16px",
        height: "1px",
        backgroundColor: theme.palette.get("grey"),
    },
    list: {
        margin: "4px 0px 0px 0px",
        padding: 0,
        listStyle: "none",
        "& li": {
            margin: "0px -16px",
            padding: "8px 16px",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: theme.palette.get("primary"),
                color: "#fff",
            },
        },
    },
    overlay: {
        paddingTop: "26px !important",
    },
    icon: {
        fontSize: "2.5rem !important",
    },
    popUp: {
        padding: "8px 16px 0px 16px !important",
        height: "auto !important",
        overflowY: "auto !important",
    },
});
export default function Actions(props) {
    var _a, _b;
    const classes = useClasses(styles);
    const { user, i18n } = props;
    const showTeams = props.onTeamAdd ||
        (((_a = user.teams) === null || _a === void 0 ? void 0 : _a.length) && props.onTeamChange) ||
        (user.currentTeam && props.onTeamSettings);
    return (React.createElement(PopUp, { anchor: props.anchor, onClose: props.onClose, override: {
            menu: classes.popUp,
        } },
        React.createElement(StateHandler, { state: props.state, override: { overlay: classes.overlay, icon: classes.icon } },
            showTeams && (React.createElement(React.Fragment, null,
                React.createElement("h4", { className: classes.menuSection }, i18n.get("teams")),
                React.createElement("ul", { className: classes.list },
                    props.onTeamAdd && (React.createElement("li", { onClick: props.onTeamAdd }, i18n.get("new_team"))),
                    ((_b = user.teams) === null || _b === void 0 ? void 0 : _b.length) && props.onTeamChange && (React.createElement("li", { onClick: props.onTeamChange }, i18n.get("change_team"))),
                    user.currentTeam && props.onTeamSettings && (React.createElement("li", { onClick: props.onTeamSettings }, i18n.get("team_settings")))),
                React.createElement("div", { className: classes.seperator }))),
            React.createElement("h4", { className: classes.menuSection }, i18n.get("account")),
            React.createElement("ul", { className: classes.list },
                props.onSettings && (React.createElement("li", { onClick: props.onSettings }, i18n.get("settings"))),
                React.createElement("li", { onClick: props.onSignOut }, i18n.get("sign_out"))))));
}
